import { render, staticRenderFns } from "./reclass-edit.vue?vue&type=template&id=7722b99e&"
import script from "./reclass-edit.vue?vue&type=script&lang=js&"
export * from "./reclass-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports